import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})

export class RutService {
  transform(rut: String) : String {
    if (rut === null || rut === undefined)
      return "";
    else if (rut.length < 2)
      return rut;
    else if (this.ValidaRut(rut)){
      rut = this.cleanSecureRut(rut);
      var result = rut.slice(-4, -1) + '-' + rut.substr(rut.length - 1);
      for (var i = 4; i < rut.length; i += 3) {
        result = rut.slice(-3 - i, -i) + '.' + result;
      }
      return result;
    }
    return rut;
  }
  
  ValidaRut(rut: String) : Boolean {
    if (typeof rut !== 'string') {
      return false;
    }

    if (!/^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/.test(rut)) {
      return false;
    }
  
    rut = this.clean(rut);
    if (rut.length < 8)
      return false;
  
    var t = parseInt(rut.slice(0, -1), 10);
    var m = 0;
    var s = 1;
  
    while (t > 0) {
      s = (s + (t % 10) * (9 - m++ % 6)) % 11;
      t = Math.floor(t / 10);
    }
  
    var v = s > 0 ? '' + (s - 1) : 'K';
    return v === rut.slice(-1);
  }

  clean (rut) {
    return typeof rut === 'string' ? rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase() : '';
  }

  cleanSecureRut (rut) {
    return typeof rut === 'string' ? rut.replace(/[\.-]/g, "").toUpperCase() : '';
  }
}